/**
 * Majlis Mart - core theme JavaScript: shared helpers, mobile menu, focus trapping,
 * announcement-bar rotation and global keyboard handling.
 * (Quick-add lives ONLY in cart-drawer.js.)
 */
(function () {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // Supports every Shopify money format token.
  function formatMoney(cents, format) {
    const fmt = format || (window.theme && window.theme.moneyFormat) || '{{amount}} AED';
    const n = Number(cents) || 0;
    function num(value, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      const parts = (value / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, token) => {
      switch (token) {
        case 'amount': return num(n, 2);
        case 'amount_no_decimals': return num(n, 0);
        case 'amount_with_comma_separator': return num(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(n, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(n, 0, ' ');
        case 'amount_with_space_separator': return num(n, 2, ' ', ',');
        default: return num(n, 2);
      }
    });
  }

  function toast(message) {
    const el = document.createElement('div');
    el.className = 'mm-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 4000);
  }

  // Visible, focusable elements inside a container (used by the focus trap).
  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'),
      (el) => !el.disabled && el.tabIndex >= 0 && el.type !== 'hidden' && el.getClientRects().length > 0
    );
  }

  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    const nodes = focusables(container);
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  window.MM = { root, escapeHtml, formatMoney, toast, trapFocus };

  document.addEventListener('DOMContentLoaded', () => {
    // ---------- Mobile menu ----------
    const drawer = document.querySelector('[data-mobile-menu-drawer]');
    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    const backdrop = document.querySelector('[data-mobile-menu-backdrop]');

    if (drawer && !drawer.id) drawer.id = 'MobileMenuDrawer';
    if (openBtn) {
      openBtn.setAttribute('aria-haspopup', 'dialog');
      openBtn.setAttribute('aria-expanded', 'false');
      if (drawer) openBtn.setAttribute('aria-controls', drawer.id);
    }

    function openMenu() {
      if (!drawer) return;
      drawer.classList.add('is-active');
      document.body.classList.add('drawer-open');
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      closeBtn && closeBtn.focus();
    }
    function closeMenu() {
      if (!drawer || !drawer.classList.contains('is-active')) return;
      drawer.classList.remove('is-active');
      document.body.classList.remove('drawer-open');
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
      openBtn && openBtn.focus();
    }
    openBtn && openBtn.addEventListener('click', openMenu);
    closeBtn && closeBtn.addEventListener('click', closeMenu);
    backdrop && backdrop.addEventListener('click', closeMenu);
    window.addEventListener('resize', () => { if (window.innerWidth >= 750) closeMenu(); });

    document.querySelectorAll('[data-mobile-submenu-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const submenu = btn.parentElement && btn.parentElement.nextElementSibling;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        const icon = btn.querySelector('svg');
        icon && icon.classList.toggle('rotate-180');
        if (submenu && submenu.classList.contains('mobile-submenu')) submenu.classList.toggle('hidden');
      });
    });

    // ---------- Keyboard: Escape closes overlays, Tab stays inside the open one ----------
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        const openOverlay = document.querySelector('.cart-drawer.is-active, .mobile-menu-drawer.is-active, .image-zoom-modal.is-active, .exit-intent-modal.is-active');
        if (openOverlay) trapFocus(openOverlay, e);
        return;
      }
      if (e.key !== 'Escape') return;
      closeMenu();
      if (window.CartDrawer) window.CartDrawer.close();
      const zoom = document.getElementById('ProductZoomModal');
      if (zoom && zoom.classList.contains('is-active')) {
        zoom.classList.remove('is-active');
        document.body.classList.remove('drawer-open');
      }
    });

    // ---------- Announcement bar rotation ----------
    document.querySelectorAll('[data-section-type=announcement-bar]').forEach((bar) => {
      const items = Array.prototype.slice.call(bar.querySelectorAll('.announcement-item'));
      if (items.length < 2 || bar.dataset.autoRotate !== 'true') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const speed = Math.max(3000, parseInt(bar.dataset.rotationSpeed, 10) || 4000);
      let index = 0;
      let paused = false;
      let timer = null;

      function show(n) {
        items.forEach((el, k) => el.classList.toggle('hidden', k !== n));
      }
      function start() {
        stop();
        timer = setInterval(() => {
          if (paused) return;
          index = (index + 1) % items.length;
          show(index);
        }, speed);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      bar.addEventListener('mouseenter', () => { paused = true; });
      bar.addEventListener('mouseleave', () => { paused = false; });
      bar.addEventListener('focusin', () => { paused = true; });
      bar.addEventListener('focusout', () => { paused = false; });
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
      show(0);
      start();
    });
  });
})();
